export const useEditor = ({
  formGenerator = () => ({}),
  withRefForm = true,
  setterName = 'setForm',
  formName = 'form',
} = {}) => ({
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    creator: Boolean,
  },
  data: () => ({ [formName]: {} }),
  methods: {
    [setterName]() {
      Object.assign(this, {
        [formName]: this.creator ? formGenerator() : { ...this.item },
      });
      if (withRefForm) {
        this.$_resetFormValidation();
      }
    },
  },
});
